<template>
  <a :href="whatsappUrl" rel="nofollow" target="_blank" @click="onContact"
    class="fixed bottom-[14px] right-[14px] p-[18px] rounded-full bg-[#24d366] cursor-pointer z-[100] lg:p-[31px] md:right-[10%] md:bottom-[10%]">
    <img class="hidden lg:block invert" src="/img/icons/whatsapp.svg" width="66" alt="">
    <img class="lg:hidden invert" src="/img/icons/whatsapp.svg" width="32" alt="">
  </a>
</template>

<script setup>
import { useWhatsappUrl } from '@/composables/useWhatsappUrl'
import { trackTiktokEvent } from '@/composables/useTiktokEvent'

const { whatsappUrl } = useWhatsappUrl('Olá, gostaria de simular minha antecipação do FGTS.')

function onContact() {
  trackTiktokEvent('Contact')
}
</script>
